/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './two-factor-auth-recovery-modal.component.html';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';
import {TwoFactorAuthRecoveryApiService} from '../../common/controller/two-factor-auth-recovery-api.service';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule],
  selector: 'adn-two-factor-auth-recovery-modal',
  template
})
export class TwoFactorAuthRecoveryModalComponent implements OnInit {
  userId: string;
  networkId: string;

  verifyUserId: string | null = null;
  usersLoading = true;
  verifyingUsersLoading = true;
  users: any[] = [];
  verifyingUsers: any[] = [];
  errorMessage: string | null = null;
  pending = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly twoFactorAuthRecoveryApi: TwoFactorAuthRecoveryApiService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.twoFactorAuthRecoveryApi.getRecoveryUsers(this.userId, this.networkId).subscribe((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.users = page !== null ? page.results : [];
        this.usersLoading = false;
      });
    });
    this.twoFactorAuthRecoveryApi.getVerifyingUsers(this.userId).subscribe((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.verifyingUsers = page !== null ? page.results : [];
        this.verifyingUsersLoading = false;
      });
    });
  }

  saveAndClose(): void {
    if (this.pending) {
      return;
    }

    this.pending = true;
    this.errorMessage = null;
    this.twoFactorAuthRecoveryApi.submitVerifyUser(this.userId, this.verifyUserId, this.networkId)
      .subscribe({
        next: (result: any) => {
        if (result === true) {
          this.bsModalRef.hide();
        } else {
          deferMarkForCheck(this.cdr, () => {
            this.errorMessage = result.data.text;
            this.pending = false;
          });
        }
        },
        error: () => {
          deferMarkForCheck(this.cdr, () => {
            this.pending = false;
          });
        }
      });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
